import React, { useState } from 'react'
import './StartCareForm.css'
import { IoCallOutline } from 'react-icons/io5'
import emailjs from '@emailjs/browser';

const StartCareForm = () => {

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    zipCode: '',
    city: '',
    howDidYouHear: '',
    message: '',
    consent: false,
  });

  const [status, setStatus] = useState({
    message: '',
    isError: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.city || !formData.howDidYouHear || !formData.message) {
      setStatus({
        message: 'Please fill in all required fields',
        isError: true
      });
      return;
    }

    try {
      const templateParams = {
        from_name: `${formData.firstName} ${formData.lastName}`,
        from_email: formData.email,
        phone: formData.phone || 'Not provided',
        zip_code: formData.zipCode || 'Not provided',
        city: formData.city || 'Not provided',
        how_did_you_hear: formData.howDidYouHear || 'Not provided',
        message: formData.message,
        consent: formData.consent ? 'Consent given' : 'Consent not given',
      };

      // Replace these values with your actual EmailJS service, template, and public key if needed
      await emailjs.send(
        'service_5tqzyv3',
        'template_r8lo4tf',
        templateParams,
        'gv3wXk_3A6CaX8X6Q'
      );

      setStatus({
        message: 'Thank you for your message. We will get back to you soon!',
        isError: false
      });

      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        zipCode: '',
        city: '',
        howDidYouHear: '',
        message: '',
        consent: false,
      });

    } catch (error) {
      setStatus({
        message: 'There was an error sending your message. Please try again.',
        isError: true
      });
    }
  };
    

  return (
    <div>
        <form className="contact-form-container" onSubmit={handleSubmit}>
              
          <div className='contact-form-header'>
            <IoCallOutline style={{fontSize: '40px', color: 'white'}} />
            <h3>Start Care Now<br /><span>(925) 844-3054</span></h3>
          </div>

          <input
            type="text"
            placeholder='First Name'
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            placeholder='Last Name'
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            placeholder='Email'
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            placeholder='Cell Phone Number'
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            placeholder='City'
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            placeholder='Zip Code'
            name="zipCode"
            value={formData.zipCode}
            onChange={handleChange}
          />
          <input
            type="text"
            placeholder='How did you hear about us?'
            name="howDidYouHear"
            value={formData.howDidYouHear}
            onChange={handleChange}
            required
          />

          <textarea
            placeholder='Any information that would be helpful for us to know about your postpartum needs.'
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <label className="consent-checkbox">
            <input
              type="checkbox"
              name="consent"
              checked={formData.consent}
              onChange={handleChange}
            />
            I consent to be contacted by email or phone.
          </label>

          {status.message && (
            <div className={`status-message ${status.isError ? 'error' : 'success'}`}>
              {status.message}
            </div>
          )}
          <button type='submit'>
            Submit
          </button>
        </form>
    </div>
  )
}

export default StartCareForm